import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUsersTwoFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19 18.66a1 1 0 0 1-.352-1.937c.572-.215.572-.41.572-.515 0-.465-1.089-.677-1.557-.746a1 1 0 1 1 .293-1.979c2.697.401 3.264 1.703 3.264 2.725 0 .63-.243 1.776-1.869 2.388a1 1 0 0 1-.352.064M15.868 11.947a1 1 0 0 1-.14-1.99A2.03 2.03 0 0 0 17.47 7.96c0-.995-.712-1.835-1.694-1.996a1 1 0 0 1 .326-1.974 4.01 4.01 0 0 1 3.368 3.97c0 1.987-1.488 3.697-3.46 3.978a1 1 0 0 1-.142.01M9.88 12.516a4.736 4.736 0 0 0 4.732-4.728 4.737 4.737 0 0 0-4.733-4.73 4.737 4.737 0 0 0-4.733 4.73 4.736 4.736 0 0 0 4.733 4.728M9.88 14.498c-3.049 0-7.1.333-7.1 3.211 0 3.23 5.343 3.23 7.1 3.23 3.047 0 7.1-.332 7.1-3.211 0-3.23-5.345-3.23-7.1-3.23"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUsersTwoFilled);
export default ForwardRef;
